export default __webpack_public_path__ + "static/media/python-icon.8bbef9f8.svg";